(function() {
  // キーワード → URLスラグのマッピング（Edge側のKEYWORD_SLUG_MAPと同期）
  var KEYWORD_SLUG_MAP = {
    '補助金': 'grant',
    '未経験': 'inexperience',
    '基礎': 'basic',
    '応用': 'advanced',
    '初心者': 'beginner',
    '入門': 'introduction'
  };
  var SLUG_TO_KEYWORD = {};
  Object.keys(KEYWORD_SLUG_MAP).forEach(function(k) {
    SLUG_TO_KEYWORD[KEYWORD_SLUG_MAP[k]] = k;
  });

  // 一覧結果の見出し（フィルタ操作・ソート・ページ送り後にここへスクロール）
  var LIST_ANCHOR = '#seopv-training-list-heading';

  // ハイブリッドURL構築関数（§6.4）
  // 1つ目のカテゴリはパス、2つ目以降はクエリパラメータとして構築
  // キーワードはパスサフィックスとして出力（例: /languages/lan1/grant/）
  function buildFacetPath(currentPath, categoryToToggle, valueToToggle, isRemove) {
    var BASE = '/apps/training-search';
    var MAP = window.__FACET_SLUG_MAP__ || {};
    var FACET_CATS = new Set(Object.keys(MAP));

    // slugからvalueへの逆引き用マップを構築
    var slugToValue = {};
    Object.keys(MAP).forEach(function(cat) {
      slugToValue[cat] = {};
      var catMap = MAP[cat];
      Object.keys(catMap).forEach(function(val) {
        slugToValue[cat][catMap[val]] = val;
      });
    });

    // 現在のパスからフィルターを解析（1つ目のカテゴリのみ）
    var relative = currentPath.replace(BASE, '').replace(/^\/+/, '').replace(/\/+$/, '');
    var segments = relative ? relative.split('/').filter(Boolean) : [];
    var filters = {};
    var isRecommendPage = false;
    var existingKeyword = null; // 単一キーワード（ラジオボタン）

    // パス末尾のキーワードスラグを検出して切り離す
    if (segments.length > 0 && SLUG_TO_KEYWORD[segments[segments.length - 1]]) {
      existingKeyword = SLUG_TO_KEYWORD[segments[segments.length - 1]];
      segments = segments.slice(0, -1);
    }

    // パスから1つ目のカテゴリを取得
    if (segments.length >= 2 && slugToValue[segments[0]]) {
      var slug = segments[1];
      if (slug !== 'recommend') {
        var val = slugToValue[segments[0]] && slugToValue[segments[0]][slug];
        if (val) {
          filters[segments[0]] = val;
        }
      }
    }

    // パスに recommend が含まれているか判定
    if (segments.indexOf('recommend') !== -1) {
      isRecommendPage = true;
    }

    // クエリパラメータから追加カテゴリを取得（keywordsはパスから取得済み）
    var search = window.location.search;
    if (search) {
      var params = new URLSearchParams(search);
      params.forEach(function(value, key) {
        if (FACET_CATS.has(key) && value && !filters[key]) {
          // まずスラグとしてルックアップ（例: hie5 → 中堅社員）
          var facetVal = slugToValue[key] && slugToValue[key][value];
          if (!facetVal && MAP[key]) {
            // スラグで見つからない場合、生の値として逆引き（例: 中堅社員 がそのまま渡された場合）
            var catMap = MAP[key];
            Object.keys(catMap).forEach(function(val) {
              if (val === value) facetVal = val;
            });
          }
          if (facetVal) {
            filters[key] = facetVal;
          }
        }
      });
    }

    // カテゴリの追加/削除を適用
    if (categoryToToggle === 'keywords') {
      // ラジオボタン方式: 単一キーワードの切り替え
      if (isRemove) {
        existingKeyword = null;
      } else if (valueToToggle) {
        // 同じキーワードを再選択 → 解除、異なるキーワード → 切り替え
        existingKeyword = (existingKeyword === valueToToggle) ? null : valueToToggle;
      }
      // keywordsがある場合はrecommendを除外
      if (existingKeyword) {
        isRecommendPage = false;
      }
    } else if (isRemove) {
      delete filters[categoryToToggle];
    } else if (categoryToToggle && valueToToggle) {
      // 単一選択制限: 同一カテゴリは常に上書き
      filters[categoryToToggle] = valueToToggle;
    }

    // ハイブリッドURL構築: 1つ目のカテゴリをパス、残りをクエリパラメータ
    var CATEGORY_PRIORITY = {
      'hierarchies': 0, 'training_types': 1, 'themes': 2, 'languages': 3,
      'price_ranges': 4, 'durations': 5, 'formats': 6, 'occupations': 7, 'companies': 8
    };
    var sortedCategories = Object.keys(filters).sort(function(a, b) {
      return (CATEGORY_PRIORITY[a] !== undefined ? CATEGORY_PRIORITY[a] : 99) - (CATEGORY_PRIORITY[b] !== undefined ? CATEGORY_PRIORITY[b] : 99);
    });
    var pathParts = [];
    var queryParts = [];
    var firstHandled = false;

    sortedCategories.forEach(function(cat) {
      var value = filters[cat];
      var slug = MAP[cat] && MAP[cat][value];
      if (slug) {
        if (!firstHandled) {
          pathParts.push(cat, slug);
          firstHandled = true;
        } else {
          queryParts.push(cat + '=' + slug);
        }
      }
    });

    // recommendをパスに追加（keywordsがない場合のみ）
    if (isRecommendPage && !existingKeyword) {
      pathParts.push('recommend');
    }

    // キーワードをパスサフィックスとして追加（recommendとは共存不可）
    if (existingKeyword && KEYWORD_SLUG_MAP[existingKeyword]) {
      pathParts.push(KEYWORD_SLUG_MAP[existingKeyword]);
    }

    var url;
    if (pathParts.length > 0) {
      url = BASE + '/' + pathParts.join('/') + '/';
    } else {
      url = BASE + '/';
    }

    if (queryParts.length > 0) {
      url += '?' + queryParts.join('&');
    }
    return url;
  }

  // Sticky Header Shadow on Scroll (PC & SP) - 統合版
  var stickyElements = document.querySelectorAll('.pc-sticky-filters, .sp-sticky-header');
  if (stickyElements.length > 0) {
    var stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        e.target.classList.toggle('is-stuck', e.intersectionRatio < 1);
      });
    }, { threshold: [1], rootMargin: '-1px 0px 0px 0px' });
    
    stickyElements.forEach(function(el) {
      stickyObserver.observe(el);
    });
  }
  
  // SP Reset Button Handler - 全フィルタをクリアしてトップページに遷移
  const spResetBtns = document.querySelectorAll('.sp-reset-link');
  spResetBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      showPageLoading();
      window.location.href = '/apps/training-search/' + LIST_ANCHOR;
    });
  });

  // PC Reset Button Handler - 全フィルタをクリアしてトップページに遷移
  const pcResetBtns = document.querySelectorAll('.pc-reset-link');
  pcResetBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      showPageLoading();
      window.location.href = '/apps/training-search/' + LIST_ANCHOR;
    });
  });

// Swiper初期化関数（最適化版）
function initializeSwiper(selector, navigationConfig) {
  var swiperEl = document.querySelector(selector);
  if (!swiperEl || !swiperEl.querySelector('.swiper-slide')) return null;
  if (swiperEl.swiper) return swiperEl.swiper; // 既に初期化済みならスキップ
  
  return new Swiper(selector, {
    slidesPerView: 'auto',
    spaceBetween: 0,
    freeMode: false,
    navigation: navigationConfig,
    grabCursor: true,
    mousewheel: { forceToAxis: true },
    watchOverflow: true
  });
}

// Swiper一括初期化（1回のみ実行）
var swipersInitialized = false;
function initAllSwipers() {
  if (swipersInitialized || typeof Swiper === 'undefined') return;
  swipersInitialized = true;

  initializeSwiper('.popular-swiper', {
    nextEl: '.swiper-button-next.popular-next',
    prevEl: '.swiper-button-prev.popular-prev'
  });

  initializeSwiper('.interview-swiper', {
    nextEl: '.swiper-button-next.interview-next',
    prevEl: '.swiper-button-prev.interview-prev'
  });

  initializeSwiper('.cross-link-swiper', {
    nextEl: '.swiper-button-next.cross-link-next',
    prevEl: '.swiper-button-prev.cross-link-prev'
  });

  // 関連カテゴリカルーセル
  document.querySelectorAll('.popular-section[data-swiper-index]').forEach(function(section) {
    var swiperEl = section.querySelector('.swiper');
    if (!swiperEl || !swiperEl.querySelector('.swiper-slide') || swiperEl.swiper) return;
    
    new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: false,
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev')
      },
      grabCursor: true,
      mousewheel: { forceToAxis: true },
      watchOverflow: true
    });
  });

  // カテゴリLPカルーセル
  document.querySelectorAll('.landing-tab-content[data-carousel-index]').forEach(function(tabContent) {
    var swiperEl = tabContent.querySelector('.landing-carousel-swiper');
    if (!swiperEl || !swiperEl.querySelector('.swiper-slide') || swiperEl.swiper) return;
    
    new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: false,
      navigation: {
        nextEl: tabContent.querySelector('.swiper-button-next'),
        prevEl: tabContent.querySelector('.swiper-button-prev')
      },
      grabCursor: true,
      mousewheel: { forceToAxis: true },
      watchOverflow: true
    });
  });
}

// Swiper初期化: load時に1回のみ実行
window.addEventListener('load', initAllSwipers, { once: true });

// リサイズ時は更新のみ（再初期化しない）
var resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    document.querySelectorAll('.swiper').forEach(function(el) {
      if (el.swiper) el.swiper.update();
    });
  }, 250);
}, { passive: true });

  // Scroll to Top（スロットリング最適化）
  var scrollToTopBtn = document.getElementById('scrollToTop');
  if (scrollToTopBtn) {
    var scrollTicking = false;
    window.addEventListener('scroll', function() {
      if (!scrollTicking) {
        requestAnimationFrame(function() {
          scrollToTopBtn.classList.toggle('visible', window.pageYOffset > 300);
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    }, { passive: true });
        
    scrollToTopBtn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // Suggestions (PC & SP対応版)
  const searchInput = document.getElementById('searchInput');
  const suggestionsDropdown = document.getElementById('suggestionsDropdown');
  const spSearchInput = document.querySelector('.sp-search-input');
  let currentFocus = -1;
  let debounceTimer;

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function formatDateJP(dateStr) {
    if (!dateStr) return '';
    var date = new Date(dateStr);
    var jpDate = new Date(date.getTime() + 9 * 60 * 60 * 1000);
    var year = jpDate.getUTCFullYear();
    var month = jpDate.getUTCMonth() + 1;
    var day = jpDate.getUTCDate();
    return year + '年' + month + '月' + day + '日';
  }

  // サジェスト機能のセットアップ関数（共通化）
  function setupSuggestions(inputElement, dropdownElement) {
    if (!inputElement || !dropdownElement) return;

    inputElement.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      const query = this.value.trim();
        
      if (query.length === 0) {
        dropdownElement.classList.remove('active');
        return;
      }

      debounceTimer = setTimeout(async () => {
        try {
          const apiUrl = window.location.origin + '/apps/training-search/suggestions?q=' + encodeURIComponent(query);
            
          const response = await fetch(apiUrl);
          const suggestions = await response.json();
            
          if (suggestions && suggestions.length > 0) {
            dropdownElement.innerHTML = suggestions.map((suggestion, index) => 
              '<div class="suggestion-item" data-index="' + index + '">' + escapeHtml(suggestion) + '</div>'
            ).join('');
            dropdownElement.classList.add('active');
            currentFocus = -1;
          } else {
            dropdownElement.classList.remove('active');
          }
        } catch (error) {
          console.error('Suggestions Error:', error);
          dropdownElement.classList.remove('active');
        }
      }, 300);
    });

    inputElement.addEventListener('keydown', function(e) {
      const items = dropdownElement.querySelectorAll('.suggestion-item');
        
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        currentFocus++;
        if (currentFocus >= items.length) currentFocus = 0;
        setActive(items);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        currentFocus--;
        if (currentFocus < 0) currentFocus = items.length - 1;
        setActive(items);
      } else if (e.key === 'Enter') {
        if (currentFocus > -1 && items[currentFocus]) {
          e.preventDefault();
          inputElement.value = items[currentFocus].textContent;
          dropdownElement.classList.remove('active');
          inputElement.closest('form').submit();
        }
      } else if (e.key === 'Escape') {
        dropdownElement.classList.remove('active');
        currentFocus = -1;
      }
    });

    dropdownElement.addEventListener('click', function(e) {
      if (e.target.classList.contains('suggestion-item')) {
        inputElement.value = e.target.textContent;
        dropdownElement.classList.remove('active');
        inputElement.closest('form').submit();
      }
    });

    document.addEventListener('click', function(e) {
      if (!inputElement.contains(e.target) && !dropdownElement.contains(e.target)) {
        dropdownElement.classList.remove('active');
        currentFocus = -1;
      }
    });
  }

  function setActive(items) {
    items.forEach((item, index) => {
      item.classList.toggle('selected', index === currentFocus);
    });
    if (items[currentFocus]) {
      items[currentFocus].scrollIntoView({ block: 'nearest' });
    }
  }

  // PC用サジェスト
  if (searchInput && suggestionsDropdown) {
    setupSuggestions(searchInput, suggestionsDropdown);
  }

  // SP用サジェスト
  if (spSearchInput) {
    // SP用のドロップダウン要素を動的生成
    const spSuggestionsDropdown = document.createElement('div');
    spSuggestionsDropdown.className = 'suggestions-dropdown sp-suggestions-dropdown';
    spSearchInput.parentElement.appendChild(spSuggestionsDropdown);
    
    setupSuggestions(spSearchInput, spSuggestionsDropdown);
  }

  // フィルター×ボタンクリック時の処理（ディレクトリ型URL対応）
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('filter-clear-btn')) {
      e.preventDefault();
      e.stopPropagation();
      showPageLoading();
      var category = e.target.dataset.category;
      // パスからカテゴリを除去してディレクトリ型URLを構築
      window.location.href = buildFacetPath(window.location.pathname, category, null, true) + LIST_ANCHOR;
    }
  });

  // フィルタードロップダウンの制御
  const filterSections = document.querySelectorAll('.filter-section');
  filterSections.forEach(function(section) {
    const heading = section.querySelector('.filter-section-title');
    if (heading) {
      heading.addEventListener('click', function(e) {
        // ×ボタンがクリックされた場合は何もしない
        if (e.target.classList.contains('filter-clear-btn')) {
          return;
        }
        
        e.preventDefault();
        e.stopPropagation();
        
        filterSections.forEach(function(otherSection) {
          if (otherSection !== section) {
            otherSection.classList.remove('open');
          }
        });
        
        section.classList.toggle('open');
        
        // SP表示時にドロップダウンの位置を調整
        if (window.innerWidth <= 768 && section.classList.contains('open')) {
          const dropdown = section.querySelector('.filter-options');
          if (dropdown) {
            // スタイルをリセット
            dropdown.style.left = '';
            dropdown.style.right = '';
            dropdown.style.transform = '';
            
            const filtersGrid = section.closest('.sp-filters-grid');
            if (!filtersGrid) return; // sp-filters-gridが見つからない場合は終了
            const allSections = Array.from(filtersGrid.querySelectorAll('.filter-section'));
            const index = allSections.indexOf(section);
            const rowPosition = index % 3; // 0=左列, 1=中央列, 2=右列
            
            if (rowPosition === 0) {
              // 左列：左を軸に展開（デフォルト）
              dropdown.style.left = '0';
              dropdown.style.right = 'auto';
            } else if (rowPosition === 1) {
              // 中央列：中央を軸に展開
              dropdown.style.left = '50%';
              dropdown.style.right = 'auto';
              dropdown.style.transform = 'translateX(-50%)';
            } else if (rowPosition === 2) {
              // 右列：右を軸に展開
              dropdown.style.left = 'auto';
              dropdown.style.right = '0';
            }
          }
        }
      });
    }
  });

  document.addEventListener('click', function(e) {
    // 1. ドロップダウンを閉じる既存処理
    const isFilterClick = e.target.closest('.filter-section');
    if (!isFilterClick) {
      filterSections.forEach(function(section) {
        section.classList.remove('open');
      });
    }

    // 2. 追加修正: テキスト部分クリック時のラジオボタン連動
    // .filter-option（行全体）のクリックを検知
    const filterOption = e.target.closest('.filter-option');
    if (filterOption) {
      // ラジオボタン自体を直接クリックした場合は何もしない（下のclickハンドラに任せる）
      if (e.target.classList.contains('filter-checkbox')) return;

      // ラベルや余白をクリックした場合、ネイティブの重複動作を防ぐためにデフォルト動作を無効化
      e.preventDefault();

      const radio = filterOption.querySelector('.filter-checkbox');
      if (radio) {
        // ラジオボタンのクリック解除対応
        if (radio.dataset.wasChecked === 'true') {
          radio.checked = false;
          radio.dataset.wasChecked = 'false';
          showPageLoading();
          var newPath = buildFacetPath(window.location.pathname, radio.dataset.category || radio.name, radio.value, true);
          window.location.href = newPath + LIST_ANCHOR;
          return;
        }
        // 同カテゴリの全ラジオのwasCheckedをリセット
        var cat = radio.dataset.category || radio.name;
        document.querySelectorAll('input.filter-checkbox[data-category="' + cat + '"]').forEach(function(r) {
          r.dataset.wasChecked = 'false';
        });
        radio.checked = true;
        radio.dataset.wasChecked = 'true';

        // changeイベントを手動発火させて、既存のURL更新・遷移ロジックを起動
        const event = new Event('change', { bubbles: true });
        radio.dispatchEvent(event);
      }
    }
  });

  // ローディングオーバーレイを表示する関数
  function showPageLoading() {
    const overlay = document.getElementById('pageLoadingOverlay');
    if (overlay) {
      overlay.classList.add('active');
    }
  }

  // bfcache復元時にローディングオーバーレイを非表示にする
  window.addEventListener('pageshow', function(event) {
    var overlay = document.getElementById('pageLoadingOverlay');
    if (overlay) overlay.classList.remove('active');
  });

  // ファセットフィルタ ラジオボタンのクリック解除対応
  // ラジオボタンは通常再クリックで解除できないため、data-was-checked属性で状態管理
  document.addEventListener('click', function(e) {
    var radio = e.target.closest('.filter-checkbox');
    if (radio && radio.type === 'radio') {
      if (radio.dataset.wasChecked === 'true') {
        // 選択済みを再クリック → 解除して遷移
        radio.checked = false;
        radio.dataset.wasChecked = 'false';
        showPageLoading();
        var cat = radio.dataset.category || radio.name;
        var newPath = buildFacetPath(window.location.pathname, cat, radio.value, true);
        window.location.href = newPath + LIST_ANCHOR;
        e.preventDefault();
        return;
      }
      // 同カテゴリの全ラジオのwasCheckedをリセット
      var cat = radio.dataset.category || radio.name;
      document.querySelectorAll('input.filter-checkbox[data-category="' + cat + '"]').forEach(function(r) {
        r.dataset.wasChecked = 'false';
      });
      radio.dataset.wasChecked = 'true';
    }
  });

  // キーワードラジオボタンのクリック解除対応
  document.addEventListener('click', function(e) {
    var radio = e.target.closest('.keyword-checkbox');
    if (radio && radio.type === 'radio') {
      if (radio.dataset.wasChecked === 'true') {
        radio.checked = false;
        radio.dataset.wasChecked = 'false';
        showPageLoading();
        var newPath = buildFacetPath(window.location.pathname, 'keywords', radio.value, true);
        window.location.href = newPath + LIST_ANCHOR;
        e.preventDefault();
        return;
      }
      document.querySelectorAll('.keyword-checkbox[type="radio"]').forEach(function(r) {
        r.dataset.wasChecked = 'false';
      });
      radio.dataset.wasChecked = 'true';
    }
  });
  // 初期状態でcheckedなラジオボタンにwasCheckedを設定
  document.querySelectorAll('.filter-checkbox[type="radio"]:checked').forEach(function(r) {
    r.dataset.wasChecked = 'true';
  });
  document.querySelectorAll('.keyword-checkbox[type="radio"]:checked').forEach(function(r) {
    r.dataset.wasChecked = 'true';
  });

  // ラジオボタン変更時の自動送信（ディレクトリ型URL対応 §6.3.1）
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('filter-checkbox') || e.target.classList.contains('keyword-checkbox')) {
      // ローディング表示
      showPageLoading();

      var category = e.target.dataset.category || e.target.name;
      var value = e.target.value;

      // ディレクトリ型URLを構築して遷移
      // チェックオフ時はカテゴリ除去、チェックオン時はカテゴリ追加
      var newPath = buildFacetPath(window.location.pathname, category, value, !e.target.checked);
      var refLabel = e.target.checked ? 'filter-select' : 'filter-deselect';
      window.location.href = newPath + LIST_ANCHOR;
    }
  });

  // ページネーションリンククリック時のローディング表示
  document.addEventListener('click', function(e) {
    const paginationLink = e.target.closest('.pagination a');
    if (paginationLink) {
      showPageLoading();
    }
  });

  // 検索フォーム送信時のローディング表示
  const searchForms = document.querySelectorAll('#searchForm, #spSearchForm');
  searchForms.forEach(function(form) {
    form.addEventListener('submit', function() {
      showPageLoading();
    });
  });

  // Tabs
  const landingTabs = document.querySelectorAll('.landing-tab');
  const landingTabContents = document.querySelectorAll('.landing-tab-content');
    
  landingTabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const category = this.dataset.category;
        
      landingTabs.forEach(t => t.classList.remove('active'));
      landingTabContents.forEach(c => c.classList.remove('active'));
        
      this.classList.add('active');
      const targetContent = document.querySelector('.landing-tab-content[data-category="' + category + '"]');
      if (targetContent) {
        targetContent.classList.add('active');
        
        // タブ切り替え後にSwiperを更新または初期化
        var swiperEl = targetContent.querySelector('.landing-carousel-swiper');
        if (swiperEl) {
          if (swiperEl.swiper) {
            swiperEl.swiper.update();
          } else if (typeof Swiper !== 'undefined' && swiperEl.querySelector('.swiper-slide')) {
            new Swiper(swiperEl, {
              slidesPerView: 'auto',
              spaceBetween: 0,
              freeMode: false,
              navigation: {
                nextEl: targetContent.querySelector('.swiper-button-next'),
                prevEl: targetContent.querySelector('.swiper-button-prev')
              },
              grabCursor: true,
              mousewheel: { forceToAxis: true },
              watchOverflow: true
            });
          }
        }
      }
    });
  });

  const categoryTabBtns = document.querySelectorAll('.category-tab-btn');
  const categoryTabPanels = document.querySelectorAll('.category-tab-panel');

  categoryTabBtns.forEach(function(tab) {
    tab.addEventListener('click', function() {
      const categoryKey = this.dataset.categoryKey;
      const parentSection = this.closest('.category-links-section');

      // 同じセクション内のタブとパネルのみを対象にする
      const siblingTabs = parentSection.querySelectorAll('.category-tab-btn');
      const siblingPanels = parentSection.querySelectorAll('.category-tab-panel');

      siblingTabs.forEach(t => t.classList.remove('active'));
      siblingPanels.forEach(p => p.classList.remove('active'));

      this.classList.add('active');
      const targetPanel = parentSection.querySelector('.category-tab-panel[data-category-key="' + categoryKey + '"]');
      if (targetPanel) {
        targetPanel.classList.add('active');
      }

      // v1.8 Case D: SEO 新テンプレのタブ毎 CTA も追従して切替
      const siblingCtas = parentSection.querySelectorAll('.seopv-catnav-cta');
      siblingCtas.forEach(c => c.classList.remove('active'));
      const targetCta = parentSection.querySelector('.seopv-catnav-cta[data-category-key="' + categoryKey + '"]');
      if (targetCta) {
        targetCta.classList.add('active');
      }
    });
  });

  // Sort Select Change Event
  const sortSelect = document.getElementById('sortSelect');
  const sortDescription = document.getElementById('sortDescription');
  const sortDescriptionMap = {
    'recommended': '※研修・カリキュラム名のA〜Z順',
    'newest': '※登録日順',
    'oldest': '',
    'duration_desc': '※研修日数順',
    'duration_asc': '※研修日数順',
    'price_desc': '※掲載価格順',
    'price_asc': '※掲載価格順'
  };
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      if (sortDescription) {
        sortDescription.textContent = sortDescriptionMap[this.value] || '';
      }
      showPageLoading();
      // ハイブリッドURL: ファセットクエリパラメータを保持しつつsortを追加/変更
      var basePath = window.location.pathname;
      var currentParams = new URLSearchParams(window.location.search);
      var sortValue = this.value;
      // sort・page・トラッキングパラメータを除去し、ファセットカテゴリ等のみ保持
      currentParams.delete('sort');
      currentParams.delete('page');
      currentParams.delete('_ref');
      currentParams.delete('_anc');
      if (sortValue && sortValue !== 'recommended') {
        currentParams.set('sort', sortValue);
      }
      var qs = currentParams.toString();
      var sortUrl = basePath + (qs ? '?' + qs : '');
      // 新テンプレでは「自分に合う○○研修を探す」H2 (#seopv-training-list-heading) までスクロールさせる
      window.location.href = sortUrl + LIST_ANCHOR;
    });
  }

  // 完全リセットボタンの処理
  const resetAllBtn = document.getElementById('resetAllBtn');
  if (resetAllBtn) {
    resetAllBtn.addEventListener('click', function(e) {
      e.preventDefault();
      // 全フィルターをリセット（ベースURLに戻る）
      window.location.href = '/apps/training-search/' + LIST_ANCHOR;
    });
  }

})();
